module.exports = __webpack_public_path__ + "static/media/ico_video.92da0bfe.svg";